/**
 * @vuepress
 * ---
 * title: Report Sinisters Status Extranet
 */

import Transformer from '../transformer'

class sinisterTransformer extends Transformer {
  static fetch({
    id,
    provider,
    affected,
    description,
    action,
    action_user: actionUser,
    sinister = {},
    is_active: isActive,
    add_date: addDate,
    amount,
    vat,
    retention,
    action_date: actionDate,
    advance,
    date_pay: datePay,
    pay_days: payDays,
    total_request: totalRequest,
    total_paid: totalPaid,
    balance,
    date_paid: datePaid,
    application_payment_days: applicationPaymentDays
  }) {
    return {
      id,
      provider,
      affected,
      description,
      action,
      actionUser,
      sinisterNumber: sinister ? sinister.sinister_number : null,
      sinisterSlug: sinister ? sinister.slug : null,
      isActive,
      addDate,
      amount,
      vat,
      retention,
      actionDate,
      advance,
      datePay,
      payDays,
      totalRequest,
      totalPaid,
      balance,
      datePaid,
      applicationPaymentDays
    }
  }
}
export default sinisterTransformer
